import { v4 as uuidv4 } from 'uuid';
import { COOKIES } from './../constants';
import { NextApiRequest } from 'next';
import { PageType } from '../types';

export const redirectToLogin = (locale: string) => {
  const currentUrl = encodeURIComponent(location.href);
  location.href = `https://users.wix.com/signin?postLogin=${currentUrl}&postSignUp=${currentUrl}&redirectUrl=${currentUrl}&locale=${locale}`;
};

export const loginWithAnswersSSO = (redirectUrl: string, locale: string) => {
  const base = 'https://support.wix.com/api/v1/accounts/sso?redirectUrl=';
  location.href = base + encodeURIComponent(redirectUrl) + '&lang=' + locale;
};

const getCookie = (name: string) => {
  const value = '; ' + document.cookie;
  const parts = value.split('; ' + name + '=');
  if (parts?.length === 2) {
    return parts?.pop()?.split(';').shift();
  }
};

const createCookie = (
  cookieKey: string,
  value: string,
  persistenceMilliseconds?: number
) => {
  let expires = '';
  if (persistenceMilliseconds) {
    const date = new Date();
    date.setTime(date.getTime() + persistenceMilliseconds);
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = `${cookieKey}=${value}${expires}; path=/; domain=.wix.com`;
};

export const hasWixClientId = () => !!getCookie(COOKIES.WIX_CLIENT_ID);
export const setWixClientId = () => {
  const HALF_YEAR_MILLISECONDS = 5 * 365 * 24 * 60 * 60 * 1000;
  createCookie(COOKIES.WIX_CLIENT_ID, uuidv4(), HALF_YEAR_MILLISECONDS);
};
export const getWixLanguage = () => getCookie(COOKIES.WIX_LANGUAGE);
export const isUserLoggedIn = (): boolean => !!getCookie(COOKIES.WIX_CLIENT);
export const isUserLoggedInByRequest = (request: NextApiRequest): boolean =>
  !!request.cookies[COOKIES.WIX_CLIENT];
export const hasAnswersSSO = (): boolean =>
  !!getCookie(COOKIES.WIX_ANSWERS_CLIENT_ID);

export const isPersonalPage = (pageType: PageType) =>
  [PageType.Profile, PageType.Ticket].includes(pageType);
